import React from "react";
import {
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";

/**
 * Render a single stat (label + value + optional helpText).
 *
 * `colorMode`:
 *   - "fixed" (default): use the literal `color` prop (or none if omitted)
 *   - "pnl": green when value > 0, red when value < 0, default when 0/null
 *
 * Pass a number to `value` for "pnl" mode; pre-formatted strings can be
 * provided via `displayValue` (e.g. currency-formatted text from a parent).
 */
const StatCard = ({
  label,
  value,
  displayValue,
  helpText,
  fontSize = "lg",
  color,
  colorMode = "fixed",
  statProps,
  numberProps,
}) => {
  const resolvedColor = (() => {
    if (colorMode === "pnl") {
      const numeric = typeof value === "number" ? value : Number(value);
      if (!Number.isFinite(numeric) || numeric === 0) return color;
      return numeric > 0 ? "green.500" : "red.500";
    }
    return color;
  })();

  const rendered = displayValue !== undefined ? displayValue : value;

  return (
    <Stat {...statProps}>
      {label && <StatLabel>{label}</StatLabel>}
      <StatNumber fontSize={fontSize} color={resolvedColor} {...numberProps}>
        {rendered}
      </StatNumber>
      {helpText && <StatHelpText>{helpText}</StatHelpText>}
    </Stat>
  );
};

export default StatCard;
